/**
 * Mock数据，用于模拟后端API响应
 */

// 模拟登录响应
export const mockLoginResponse = {
  code: 200,
  data: {
    access_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55X2lkIjoxLCJ1c2VybmFtZSI6ImFkbWluIiwiY29tcGFueV9uYW1lIjoi56S65L6L56eR5oqA5pyJ6ZmQ5YWs5Y-4IiwiYWNjb3VudF90eXBlIjoibWFpbiIsImlzcyI6Ind6LWFkbWluIiwic3ViIjoiYWNjZXNzIiwiZXhwIjoxNzU3MDM0Mjk5LCJuYmYiOjE3NTY5NDc4OTksImlhdCI6MTc1Njk0Nzg5OX0.VjSkBdj1S2qg0oek0tq9ngTWLNXy981rwpGi-53B9ZQ",
    account_type: "main",
    company_id: 1,
    company_name: "示例科技有限公司",
    expires_at: "2025-09-05 09:04:59",
    refresh_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55X2lkIjoxLCJ1c2VybmFtZSI6ImFkbWluIiwiY29tcGFueV9uYW1lIjoi56S65L6L56eR5oqA5pyJ6ZmQ5YWs5Y-4IiwiYWNjb3VudF90eXBlIjoibWFpbiIsImlzcyI6Ind6LWFkbWluIiwic3ViIjoicmVmcmVzaCIsImV4cCI6MTc1NzU1MjY5OSwibmJmIjoxNzU2OTQ3ODk5LCJpYXQiOjE3NTY5NDc4OTl9.JLq4eRVzOvWV0iNkBd4dIRgrnovbVSMYVUflJCKg3Jk",
    username: "admin"
  },
  message: "登录成功"
}

// 模拟刷新token响应
export const mockRefreshTokenResponse = {
  code: "SUCCESS",
  data: {
    access_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55X2lkIjoxLCJ1c2VybmFtZSI6ImFkbWluIiwiY29tcGFueV9uYW1lIjoi56S65L6L56eR5oqA5pyJ6ZmQ5YWs5Y-4IiwiYWNjb3VudF90eXBlIjoibWFpbiIsImlzcyI6Ind6LWFkbWluIiwic3ViIjoiYWNjZXNzIiwiZXhwIjoxNzU3MDM0Mjk5LCJuYmYiOjE3NTY5NDc4OTksImlhdCI6MTc1Njk0Nzg5OX0.VjSkBdj1S2qg0oek0tq9ngTWLNXy981rwpGi-53B9ZQ",
    refresh_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55X2lkIjoxLCJ1c2VybmFtZSI6ImFkbWluIiwiY29tcGFueV9uYW1lIjoi56S65L6L56eR5oqA5pyJ6ZmQ5YWs5Y-4IiwiYWNjb3VudF90eXBlIjoibWFpbiIsImlzcyI6Ind6LWFkbWluIiwic3ViIjoicmVmcmVzaCIsImV4cCI6MTc1NzU1MjY5OSwibmJmIjoxNzU2OTQ3ODk5LCJpYXQiOjE3NTY5NDc4OTl9.JLq4eRVzOvWV0iNkBd4dIRgrnovbVSMYVUflJCKg3Jk",
    expires_at: "2025-09-05 09:04:59"
  },
  message: "Token刷新成功"
}

// 模拟错误响应
export const mockErrorResponse = {
  code: 500,
  message: "服务器错误"
}

// 模拟更新密码响应
export const mockUpdatePasswordResponse = {
  code: 200,
  message: "密码更新成功"
}

// 模拟网络请求延迟
export const mockRequestDelay = (ms = 500) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * 启用Mock数据
 * 在开发环境下，可以通过修改api/auth.js文件来使用mock数据
 */
export const enableMock = () => {
  if (process.env.NODE_ENV === 'development') {
    console.log('Mock数据已启用')
  }
}